import { useState } from 'react';
import api from '../api/axios';

export function useTestMessage({ templateId, activeAccountId }) {
  const [showTestModal, setShowTestModal] = useState(false);
  const [testToNumber, setTestToNumber] = useState('');
  const [testMessage, setTestMessage] = useState('');
  const [testMessageUuid, setTestMessageUuid] = useState(null);
  const [testError, setTestError] = useState(null);

  const openTestModal = () => {
    setTestToNumber('');
    setTestMessage('');
    setTestMessageUuid(null);
    setTestError(null);
    setShowTestModal(true);
  };

  const sendTestMessage = async () => {
    if (!testToNumber.trim() || !testMessage.trim()) {
      setTestError('Please enter both a phone number and a message.');
      return;
    }

    setTestError(null);
    setTestMessageUuid(null);

    try {
      const response = await api.post('/mvapi/message/test-send', {
        toNumber: testToNumber.trim(),
        message: testMessage.trim(),
        accountId: activeAccountId,
        templateId,
        priority: 1,
        channel: 'SMS',
      });
      setTestMessageUuid(response.data.message_uuid);
    } catch (error) {
      console.error('Test message error:', error);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Failed to send test message. Please try again.';
      setTestError(message);
    }
  };

  return {
    showTestModal,
    setShowTestModal,
    testToNumber,
    setTestToNumber,
    testMessage,
    setTestMessage,
    testMessageUuid,
    testError,
    openTestModal,
    sendTestMessage,
  };
}
